import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const UsaReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of Apostille for USA:</h3>
        <p>
          Attestation for USA has its own importance in the visa procedure &
          growth of the business in USA. Apostille is required as it is covered
          in the countries that are a part of the Hague Convention. There are
          policies of the USA that require documents with MEA sticker to permit
          a visitor to enter their country to stay or for business aspects. It
          is a part of safety that indicates the trustworthiness of the
          documents. Therefore, the legalization of documents becomes a
          necessity for these reasons.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Total time to get Document Apostille:</h3>
        <p>
          The time-san required for apostille for USA depends upon several
          factors such as which state the certificate was issued from, or the
          sort of documents, or the organization you need it from. Normally, it
          will take around 2-3 working days to accomplish USA Apostille services
          in Bangalore.
        </p>
      </div>
    </div>
  );
};

export default UsaReqMain;
